(() => {
  const DRAG_TOLERANCE = 6;
  const DESKTOP_SWIPE_DISTANCE = 60;
  const INIT_ATTEMPTS = 40;

  const initGallery = (section = document, attempt = 0) => {
    const gallery = section.querySelector?.('.product-media');
    const mediaList = gallery?.querySelector('.js-media-list');
    const main = mediaList?.swiper;

    if (!gallery || !mediaList) return;
    if (!main) {
      if (attempt < INIT_ATTEMPTS) {
        requestAnimationFrame(() => initGallery(section, attempt + 1));
      }
      return;
    }
    if (gallery.dataset.jcGalleryReady === 'true') return;
    gallery.dataset.jcGalleryReady = 'true';

    // Make an intentional half-screen swipe feel responsive on phones.
    main.params.longSwipesRatio = 0.25;
    main.params.longSwipesMs = 200;

    let startX = null;
    let startY = null;
    let dragging = false;
    let suppressClick = false;

    const resetPointer = () => {
      startX = null;
      startY = null;
      dragging = false;
    };

    mediaList.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      startX = event.clientX;
      startY = event.clientY;
      dragging = false;
    });

    document.addEventListener(
      'pointermove',
      (event) => {
        if (startX === null || event.pointerType !== 'mouse') return;
        const diffX = event.clientX - startX;
        const diffY = event.clientY - startY;
        if (Math.abs(diffX) > DRAG_TOLERANCE || Math.abs(diffY) > DRAG_TOLERANCE) {
          dragging = true;
        }
      },
      true
    );

    document.addEventListener(
      'pointerup',
      (event) => {
        if (startX === null || event.pointerType !== 'mouse') return;
        const diffX = event.clientX - startX;
        const diffY = event.clientY - startY;
        const shouldSuppress = dragging;
        const shouldAdvance =
          shouldSuppress &&
          Math.abs(diffX) >= DESKTOP_SWIPE_DISTANCE &&
          Math.abs(diffX) > Math.abs(diffY) * 1.2;

        suppressClick = shouldSuppress;
        resetPointer();

        if (shouldAdvance) {
          diffX < 0 ? main.slideNext() : main.slidePrev();
        }

        if (shouldSuppress) {
          window.setTimeout(() => {
            suppressClick = false;
          }, 0);
        }
      },
      true
    );

    mediaList.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true
    );

    main.on('slideChange', () => {
      const modal = document.querySelector('.js-popup-slider')?.swiper;
      if (!modal || modal.activeIndex === main.activeIndex) return;
      modal.slideTo(main.activeIndex, 0, false);
    });

  };

  const initAll = () => {
    document
      .querySelectorAll('.shopify-section.product-section')
      .forEach((section) => initGallery(section));
  };

  document.addEventListener('shopify:section:load', (event) => initGallery(event.target));
  document.addEventListener('DOMContentLoaded', initAll, { once: true });
  window.addEventListener('load', initAll, { once: true });
})();
